import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';

import { Toolbar, TableList } from './components';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const CustomerList = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [monitorings, setMonitoring] = useState([]);

  const fetchList = useCallback(async () => {
    try {
      const response = await api.get('monitorings')

      setMonitoring(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setMonitoring]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <div className={classes.root}>
      <Toolbar fetchList={fetchList} />
      <div className={classes.content}>
        <TableList monitorings={monitorings} onFetch={fetchList} />
      </div>
    </div>
  );
};

export default CustomerList;
